import { DimSymbolsCommand } from 'slotworks/commands/symbols/dim-symbols-command';
import { HighlightSymbolsCommand } from 'slotworks/commands/symbols/highlight-symbols-command';
import { StaticSymbolsCommand } from 'slotworks/commands/symbols/static-symbols-command';
import Components from 'slotworks/components/components';
import AbstractMediator from 'slotworks/mediators/abstract-mediator';
import GameState from 'slotworks/model/game-state';
import FreespinRecord from 'slotworks/model/gameplay/records/freespin-record';
import { reject } from 'slotworks/utils/collection-utils';
import Contract from 'slotworks/utils/contract';
import Point from 'slotworks/utils/geom/point';

export default class CelebrationWinsMediator extends AbstractMediator {
    public start(): Contract<void> {
        const currentRecord: any = GameState.getCurrentGame().getCurrentRecord();
        let winningPositions: Point[] = [];

        let sId = 'BN';
        let isFreeSpin: any = currentRecord.getResultsOfType(FreespinRecord) as FreespinRecord[];
        if (isFreeSpin && isFreeSpin[0]?.next_game) {
            sId = isFreeSpin[0].next_game === 'FREE_SPINS' ? 'SC' : 'BN';
        }
        let symbols = Components.matrix.getAllSymbols();
        for (let i = 0; i < symbols.length; i++) {
            if (symbols[i].symbolId === sId) {
                winningPositions.push(new Point(symbols[i].gridPosition.x - 1, symbols[i].gridPosition.y - 1));
            }
        }

        let winningSymbols = [];
        const winningSymbolIDs = [];

        for (const position of winningPositions) {
            const symbol = Components.matrix.getSymbol(position.x, position.y);
            winningSymbols.push(symbol);
            winningSymbolIDs.push(symbol.symbolId);
        }

        let remainingSymbols = reject(Components.matrix.getAllSymbols(), winningSymbols);
        DimSymbolsCommand(remainingSymbols).execute();
        return HighlightSymbolsCommand(winningSymbols);
    }

    public end() {
        StaticSymbolsCommand().execute();
    }
}



// WEBPACK FOOTER //
// ./src/Mediator/celebration-wins-mediator.ts